import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="app-footer">
      <div className="app-footer__credit">
        <img
          src="/assests/SS Logo_RGB.png"
          alt=""
          aria-hidden="true"
          className="app-footer__logo"
        />
        <span className="app-footer__prefix">Developed by</span>
        <span className="app-footer__company">Swayam Solutions</span>
      </div>
      <Link to="/privacy-policy" className="app-footer__privacy">
        Privacy Policy
      </Link>
    </footer>
  );
}
